import { render, staticRenderFns } from "./poDeps.vue?vue&type=template&id=376fad48"
import script from "./poDeps.vue?vue&type=script&lang=js"
export * from "./poDeps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports